import React, { useEffect, useRef, useState } from 'react';
import { useLocaleContext } from '../../../context/LocaleContext';
import { useOnClickOutside } from 'usehooks-ts'
import Icons from '../../Icons';
import CButton from '../CButton';

import './style.scss';

const CSearch = ({
    value,
    isActive = false,
    placeholder = '',
    hasButton = true,
    onSearch = () => {},
    onClose = () => {},
}) => {
    const [inputValue, setInputValue] = useState('');
    const $locale = useLocaleContext();
    const containerRef = useRef(null);

    useEffect(() => {
        if (isActive && value) setInputValue(value);
    }, [isActive]);

    useOnClickOutside(containerRef, onClose);

    function handleKeyPress(e) {
        if (e.key === 'Enter') onSearch(inputValue);
        if (e.key === 'Escape') onClose();
    }

    function handleChange(value) {
        setInputValue(value);

        if (!hasButton) {
            onSearch(value);
        }
    }

    function handleClearValue() {
        setInputValue('');
        onSearch('');
    }

    return (
        <div className="c-search">
            <div
                ref={containerRef}
                className="c-search-field"
            >
                {
                    !!inputValue
                    ? <CButton
                        blank
                        icon="close"
                        className="c-search-field-reset-button"
                        onClick={handleClearValue}
                    />
                    : <Icons name="search" />
                }
                <input
                    value={inputValue}
                    className="c-search-field-input"
                    type="text"
                    placeholder={!!placeholder ? placeholder : $locale.get('label.search')}
                    onKeyDown={(e) => handleKeyPress(e)}
                    onChange={(e) => handleChange(e.target.value)}
                />
                {
                    hasButton &&
                    <CButton
                        blank
                        label={$locale.get('label.find')}
                        className="c-search-field-button"
                        onClick={() => onSearch(inputValue)}
                    />
                }
            </div>
        </div>
    );
};

export default CSearch;
